import { resumoEtapasDoItem, subitemsDoItem } from "../../utils/etapasDoItem";

export const reais = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

/** "12 min", "1h05", "2 dias" desde que a comanda abriu. */
export function tempoAberta(iso, agora = Date.now()) {
  const inicio = iso ? new Date(iso).getTime() : NaN;
  if (!Number.isFinite(inicio)) return "";
  const min = Math.max(0, Math.round((agora - inicio) / 60000));
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  if (h >= 48) return `${Math.floor(h / 24)} dias`;
  return `${h}h${String(min % 60).padStart(2, "0")}`;
}

/** Item do carrinho (popup de produto / pizza) → item que o backend grava no pedido. */
export function itemDoCarrinhoParaPedido(item, allProducts = []) {
  const subitems = subitemsDoItem(item, allProducts);
  const etapas = resumoEtapasDoItem(item);
  const preco = item.final_price ?? item.sale_price ?? 0;
  return {
    id: item.id, product_id: item.id,
    nome: item.name || item.nome,
    quantidade: item.quantity || 1,
    preco,
    observacao: item.observation || null,
    photo_url: item.photo_url || null,
    combo_type: item.combo_type || null,
    ...(subitems.length ? { subitems } : {}),
    ...(etapas.length ? { etapas } : {}),
    ...(item.pizza ? { pizza: item.pizza } : {}),
    // Peso lido da balança ligada ao computador (features/balanca)
    ...(item.pesado_balanca ? { pesado_balanca: true } : {}),
    chave: String(item.cartItemId || ""),
  };
}

export const totalDoCarrinho = (cart) => cart.reduce((t, i) => t + (i.final_price ?? i.sale_price ?? 0) * (i.quantity || 1), 0);

/** Itens do pedido no formato do cupom de preparo (nome, quantidade, escolhas). */
export function itensParaPreparo(items, allProducts = []) {
  return (items || []).filter((i) => !i.deleted).map((i) => {
    const prod = (allProducts || []).find((p) => String(p.id) === String(i.id || i.product_id));
    return {
      id: i.id || i.product_id || null,
      nome: i.nome || i.name,
      quantidade: i.quantidade || i.quantity || 1,
      combo_type: i.combo_type || null,
      observacao: i.observacao || i.observation || null,
      subitems: (i.subitems || []).map((s) => ({ step_name: s.step_name, nome: s.nome })),
      ticket_route: prod?.print_config?.ticket_route || undefined,
    };
  });
}

/** Próximo número livre (1, 2, 3…) entre as comandas abertas — a sugestão da Nova comanda
 * (a mesma regra do backend, `regras.proximo_livre`). */
export function proximoNumero(abertas) {
  const usados = new Set((abertas || []).map((c) => Number(c?.numero)).filter((n) => n > 0));
  let n = 1;
  while (usados.has(n)) n += 1;
  return n;
}

/** O que a lista mostra para cada comanda, filtrado pela busca. */
export function filtrarComandas(lista, busca) {
  const termo = String(busca || "").trim().toLowerCase();
  if (!termo) return lista;
  return lista.filter((c) => [c.cliente_nome, String(c.numero), String(c.numero).padStart(2, "0"), c.rotulo]
    .some((v) => String(v || "").toLowerCase().includes(termo)));
}

export const vivos = (items) => (items || []).map((it, idx) => ({ it, idx })).filter(({ it }) => it && !it.deleted);
export const cancelados = (items) => (items || []).map((it, idx) => ({ it, idx })).filter(({ it }) => it && it.deleted);
